import {BlockProps, VictoryThemeDefinition} from 'victory';
import colors from 'shared/aptitude/colors';
import {Property} from 'csstype';

export const labelPadding = 8;
export const colorScale: Property.Color[] = [colors.b500, colors.black, colors.m600];
export const getColorOnScale = (index: number): Property.Color =>
  colorScale[index % colorScale.length];

export const pathColorScale: Property.Color[] = [
  colors.meadow600,
  colors.fountain600,
  colors.saffron600,
];
export const getPathColorOnScale = (index: number): Property.Color =>
  pathColorScale[index % pathColorScale.length];

export const chartPadding: BlockProps = {
  top: 16,
  right: 16,
  bottom: 32,
  left: 32,
};

const baseStyles = {
  width: 450,
  height: 300,
  colorScale,
};

const pathBaseStyles = {
  width: 450,
  height: 300,
  pathColorScale,
};

const baseLabelStyles = {
  fontFamily: ['"Open Sans"', 'Arial', 'Helvetica', '"sans-serif"'].join(','),
  fontSize: 12,
  padding: labelPadding,
};

const pathBaseLabelStyles = {
  fontFamily: ['"Noto Sans"', 'Helvetica', 'Arial', '"sans-serif"'].join(','),
  fontSize: 12,
  padding: labelPadding,
};

export const chartTheme = (path = false): VictoryThemeDefinition => {
  const styles = path ? pathBaseStyles : baseStyles;
  const labelStypes = path ? pathBaseLabelStyles : baseLabelStyles;

  return {
    chart: {
      ...styles,
    },
    dependentAxis: {
      style: {
        axis: {
          stroke: 'transparent',
        },
        axisLabel: labelStypes,
        tickLabels: labelStypes,
        grid: {
          stroke: colors.n300,
        },
      },
    },
    independentAxis: {
      style: {
        axis: {
          stroke: colors.n300,
        },
        axisLabel: labelStypes,
        tickLabels: labelStypes,
        grid: {
          stroke: 'transparent',
        },
      },
    },
    bar: {
      ...styles,
      padding: 100,
      width: 400,
      style: {
        labels: labelStypes,
        data: {
          fill: path ? colors.meadow600 : colors.b500,
        },
      },
    },
    line: {
      ...styles,
      style: {
        data: {
          stroke: path ? colors.meadow600 : colors.b500,
          strokeWidth: 2,
        },
        labels: labelStypes,
      },
    },
    tooltip: {
      style: {
        ...labelStypes,
        fill: colors.white,
      },
      flyoutStyle: {
        stroke: colors.n900,
        fill: colors.n900,
      },
      cornerRadius: 4,
      flyoutPadding: labelPadding,
    },
  };
};
